import script from "./Jobs.vue?vue&type=script&setup=true&lang=js"
export * from "./Jobs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__